var skipExcludedCheck = true;
document.addEventListener('crDeliveryActivated', function (e) {
  jqCR('#cr-delivery-date-label').html('Dispatch Day <a href="https://jaimelesmacarons.co.nz/pages/shipping-terms" target="_blank">(The day items leave our HQ)<br><span style="text-decoration: underline;">See our shipping information here</span></a>')
  jqCR('#delivery-date-start').attr('placeholder', 'Choose a dispatch day/time')
})

// This works on delivery stores
//var crdebug = true;

//storePickupSettings.mandatory_collections = []
var crValidateDelivery = true;
var crReloadOnError = true;
//var CrDeliveryTimeFormat = 'HH:i';

var tt = setInterval(function(){disableCheckoutButton();}, 1000);
setTimeout(function() { clearInterval(tt); }, 7000);  

document.addEventListener('crPickupActivated', function (e) { 
  console.log('*** Activated ***');
  disableCheckoutButton();
  var tt = setInterval(function(){disableCheckoutButton();}, 1000);
  setTimeout(function() { clearInterval(tt); }, 7000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){  
    checkPickupFields()
  }) 

  jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
  trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (pickupDate) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}

function activateCheckoutButton(){
    document.querySelector('[name=checkout]').disabled = false;
  }

function disableCheckoutButton(){    
    document.querySelector('[name=checkout]').disabled = true;
}

document.addEventListener('crDeliveryActivated', function (e) {
  	//console.log('delivery activated')
    var tt = setInterval(function(){disableCheckoutButton();}, 1000);
    setTimeout(function() { clearInterval(tt); }, 2000);  
    

    jqCR(document).on('change', '#delivery-date-start', function(){
      setTimeout(function(){
      console.log('check');checkDeliveryFields()
      }, 400)
      
      
    })  
    trackChange(jqCR("#delivery-date-start")[0] );    
  
    var checkExist = setInterval(function() {
            if (typeof crdebug !== 'undefined') console.log('§ Checking §')
			var isDelivery = jqCR('.cr-delivery-button').hasClass('selected')
            var deliveryZip = jqCR('#cr-delivery-zip').val()
            var deliveryTime = jqCR('.cr-delivery-datepicker').val();
            //console.log({isDelivery, deliveryZip, deliveryTime})
            if (isDelivery === true) {
              if (deliveryZip === '' || deliveryTime === '') {
                disableCheckoutButton();
              } else {
                activateCheckoutButton();
//                console.log('Clear')
//              	clearInterval(checkExist);
              }
            }           
	}, 100);
})

function checkDeliveryFields(){
  	var deliveryDate = jqCR('#delivery-date-start').val()
    if (deliveryDate) {
    	activateCheckoutButton();
    } else {
    	disableCheckoutButton()
    }
}